// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');

// @ constants
const { FIRST_STEP } = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const {
    HORMIGUERO_CARD_PRODUCT_ALIAS,
    NERUDA_CARD_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID,
    VANITY_CARD_PRODUCT_ALIAS,
} = require('constants/hiringProductInformation');
const { GC, CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCardNerudaStep1 extends React.Component {

    componentDidMount() {
         const {
            getContextTranslate,
            immFlagBasedFeatures,
            immHireCardNeruda,
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;
        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['nrd_opencredit'].preContractPdfLink;
            const product = {
                standard: immHireCardNeruda.get('standard').substr(-3),
                subtype: immHireCardNeruda.get('subtype'),
                type: immHireCardNeruda.get('type'),
            }
            const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
            if (!showIneAndRevolving) {
                requestPDFMerge(pdfurls, [product]);
            }
        } else if (!!setTermsAndCondsText) {
            //This action is also called in the last step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText(getContextTranslate('step4CheckboxText'));
        }
    }

    buildLegalConfirmationSection() {
        const { showIneAndRevolving } = this.props;
        if (!__CONTACT_CENTER__ || showIneAndRevolving) return null;

        const {
            contractName,
            getContextTranslate,
            handleAgreementCheckboxChange,
            immHireCardNeruda,
            sendMailParams,
        } = this.props;

        const immStep = immHireCardNeruda.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value={getContextTranslate('step4CheckboxText')} />;
        const agreementErrorMsg = formatText(getContextTranslate('step4CheckboxErrorMsg'));

        return (
            <ContactCenterValidationCards
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName={contractName}
                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                immStep={immStep}
                sendMailParams={sendMailParams}
            />
        );
    }

    render() {
        const {
            cardType,
            getContextTranslate,
            hireCmsKey,
            immFlagBasedFeatures,
            immHireInformation,
        } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productAlias, productInformationComponent;
        
        switch(cardType) {
            case 'neruda':
                productAlias = NERUDA_CARD_PRODUCT_ALIAS;
                break;
            case 'vanity':
                productAlias = VANITY_CARD_PRODUCT_ALIAS;
                break;
            case 'hormiguero':
                productAlias = HORMIGUERO_CARD_PRODUCT_ALIAS;
                break;
        }

        if (!!immFlagBasedFeatures && immFlagBasedFeatures.get(GC) && immFlagBasedFeatures.get('web-gc-enabled')) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={productAlias}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-neruda__step-one">
                    <FormattedText
                        className="hire-card-neruda__step-title"
                        value={getContextTranslate('step1Title')}
                    />
                    <HireInformation
                        hireCmsKey={hireCmsKey}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            );
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardNerudaStep1.propTypes = {
    cardType: PropTypes.oneOf(['neruda', 'vanity', 'hormiguero']),
    contractName: PropTypes.string,
    getContextTranslate: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardNeruda: PropTypes.object,
    immHireInformation: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object,
    setTermsAndCondsText: PropTypes.func,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardNerudaStep1;
